<div class="corporate-header" *transloco="let t" [class.corporate-header--expanded]="isExpanded()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
	<div class="corporate-header__left">
		<div class="corporate-header__logo">
			<img [src]="logo" alt="Logo" class="corporate-header__logo-img" />
		</div>
	</div>

	<div class="corporate-header__center">
		<h1 class="corporate-header__welcome" [style.color]="primaryColor">{{ t('corporateHeader.welcomeText') }} der {{ groupName }}</h1>
	</div>

	<div class="corporate-header__right">
		<a (click)="showLegalNotice()" class="corporate-header__link cursor-pointer">
			{{ t('footer.legalNotice') }}
		</a>

		<a (click)="showPrivacy()" class="corporate-header__link cursor-pointer">
			{{ t('footer.privacy') }}
		</a>
	</div>
</div>
